module.exports = __webpack_public_path__ + "img/ExitusC_Indice.fe5709c2.png";